import { temAcesso } from '@/shared/auth/temAcesso'

const Convenios = () => import('./ConvenioLista.vue')
const Detalhes = () => import('./ConvenioDetalhes.vue')

export default {
    path: 'gescon/fornecedor/convenios',
    name: 'Gescon_Convenios_Fornecedor',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    beforeEnter: (to, from, next) => {
        if (temAcesso('GESCON-FORN-CONV-00')) {
            next()
        }
    },
    children: [
        {
            path: '/gescon/fornecedor/convenios',
            name: 'Gescon_Convenios_Fornecedor',
            component: Convenios,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-FORN-CONV-00')) {
                    next()
                }
            }
        },
        {
            path: '/gescon/fornecedor/convenios/detalhes/:idConvenio',
            name: 'Gescon_Convenios_Fornecedor_Detalhar',
            component: Detalhes,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-FORN-CONV-00')) {
                    next()
                }
            }
        },
    ]
}
